import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MOBILE_NAVIGATION } from '../constants';

@Component({
  selector: 'app-navigation-mobile',
  templateUrl: './navigation-mobile.component.html',
  styleUrls: ['./navigation-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationMobileComponent {
  navTree = MOBILE_NAVIGATION;
}
